<template>
  <div v-if="visible" class="dept-filter" role="radiogroup" aria-label="Filtru după departament">
    <button
      type="button"
      role="radio"
      class="dept-filter__chip"
      :class="{ 'is-active': value === '' }"
      :aria-checked="value === ''"
      @click="$emit('input', '')"
    >
      Toate departamentele<span class="dept-filter__count">{{ items.length }}</span>
    </button>
    <button
      v-for="d in options"
      :key="d.name"
      type="button"
      role="radio"
      class="dept-filter__chip"
      :class="{ 'is-active': value === d.name }"
      :aria-checked="value === d.name"
      :title="d.name"
      @click="$emit('input', d.name)"
    >
      <v-icon v-if="d.isSef" small class="dept-filter__sef" aria-label="Șef">mdi-star-four-points</v-icon>
      <span class="dept-filter__name">{{ d.name }}</span><span class="dept-filter__count">{{ d.count }}</span>
    </button>
  </div>
</template>

<script>
// Chips on the dark band for people who belong to several departments: all of them, or one.
// v-model = department name ('' = all). Counts come from the rows the page already loaded.
export default {
  name: "DepartmentFilter",
  props: {
    value: { type: String, default: "" },
    items: { type: Array, default: () => [] },
    // row field holding the department name
    field: { type: String, required: true },
    // the user's departments from the store; rows of other departments (staff lists cover the whole
    // university) stay under "Toate departamentele" instead of one chip each
    departments: { type: Array, default: () => [] },
  },
  computed: {
    options() {
      const counts = new Map();
      this.items.forEach((row) => {
        const name = row[this.field];
        if (name) counts.set(name, (counts.get(name) || 0) + 1);
      });
      // a sub-unit reached only through the department tree (store sefSubunits) gets a chip once it has rows
      return this.departments
        .map((d) => ({ name: d.name, isSef: d.isSef, count: counts.get(d.name) || 0, inherited: !!d.inherited }))
        .filter((d) => !d.inherited || d.count > 0 || d.name === this.value);
    },
    // Only for people with several departments (admins see every department and filter by search)
    visible() {
      return this.options.length > 1;
    },
  },
};
</script>

<style scoped>
.dept-filter {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.dept-filter__chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  max-width: 100%;
  min-height: 40px;
  padding: 6px 8px 6px 14px;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.22);
  background: rgba(255, 255, 255, 0.06);
  color: #fff;
  font: inherit;
  font-size: 0.98rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.15s, border-color 0.15s;
}
.dept-filter__chip:hover {
  background: rgba(255, 255, 255, 0.12);
}
.dept-filter__chip.is-active {
  background: var(--leaf);
  border-color: var(--leaf);
  color: var(--pine-900);
}
.dept-filter__name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 360px;
}
.dept-filter__count {
  min-width: 28px;
  padding: 1px 8px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.14);
  font-size: 0.85rem;
  text-align: center;
}
.dept-filter__chip.is-active .dept-filter__count {
  background: rgba(14, 42, 33, 0.14);
}
.dept-filter__sef.v-icon {
  color: var(--leaf);
  margin-right: -2px;
}
.dept-filter__chip.is-active .dept-filter__sef.v-icon {
  color: var(--pine-900);
}
</style>
